class ModuleHeaderPrimary {
  constructor() {
    this._init();
  }

  _init() {
    const sidebar_company_toggler = document.querySelectorAll(
      '[data-open-sidebar-company]'
    );

    if (sidebar_company_toggler) {
      sidebar_company_toggler.forEach((element) => {
        element.addEventListener('click', this._toggleSidebar.bind(this));
      });
    }
  }

  _toggleSidebar() {
    const sidebar_company = document.getElementById('sidebar-company');
    if (sidebar_company) {
      sidebar_company.classList.toggle('open');

      if (sidebar_company.classList.contains('open')) {
        document.body.classList.add('sidebar-open');
      } else {
        document.body.classList.remove('sidebar-open');
      }
    }
  }

  _hideSidebar() {
    const sidebar_company = document.getElementById('sidebar-company');
    if (sidebar_company && sidebar_company.classList.contains('open')) {
      sidebar_company.classList.remove('open');
      document.body.classList.remove('sidebar-open');
    }
  }
}

export const moduleHeaderPrimary = new ModuleHeaderPrimary();
